import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../../../modules/infra/i18n';

import Modal from '../../../../common/Modal';
import DateFilter from '../../../../common/DatePickerV2';

const DownloadModal = ({
  close,
  startDate,
  endDate,
  onDateChange,
  download,
  endingDateMax,
  title,
}) => (
  <Modal
    title={title}
    close={close}
    showCloseButton
    className="c-modal_overflowable"
    bodyClassName="c-modal__body_overflowable"
  >
    <div className="u-pv++ u-ph+">
      <div className="layout layout--auto layout--small layout--bottom layout--center">
        <div className="layout__item u-min-width-280">
          <DateFilter
            range
            endDate={endingDateMax}
            onChange={onDateChange}
            from={startDate}
            to={endDate}
          />
        </div>
        <div className="layout__item">
          <button onClick={download} className="c-btn c-btn--medium">
            {t('common:download')}
          </button>
        </div>
      </div>
    </div>
  </Modal>
);
DownloadModal.propTypes = {
  close: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onDateChange: PropTypes.func.isRequired,
  download: PropTypes.func.isRequired,
};

export default DownloadModal;
